/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;


  var formatVIPPrice = function formatVIPPrice(price, vendor, compare_at_price) {
      if (localStorage.getItem('vendorData')
          && localStorage.getItem('vendorDataCSV') == window.pricing.csv && compare_at_price == null) {

          let percentValue;

          const vendorData = JSON.parse(localStorage.getItem('vendorData'));
          const vendorItem = vendorData.find(pricing => pricing.vendor === vendor);

          if (vendorItem) {
              percentValue = vendorItem.percent / 100;
          }
          if (percentValue){
             return parseInt(price,10) - (parseInt(price,10) * percentValue);
          }
      }

      return price;

    }

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };
  var formatPriceInl = function formatPrice(value) {
        return algolia.formatMoney(Number(value) * 110);
    };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio, vendor, sku = "") {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
	var curent_vendor = vendor;
    if(compare_at_price) curent_vendor = '';
    //var res = '<b>' + formatPrice(price) + '</b>';
    var add_class;
    if (sku == 'DRA98931') { 
      add_class = 'rendered';
    } else {
      add_class = '';
    }
    var res = '<b><span class="vendor-money ' + add_class +'" data-vendor="'+ curent_vendor +'" data-price="' + Number(price) * 100 +'"> ' + formatPrice(price) + '</span></b>';
      
    return res;
  }


    var formatPriceProductTile = function formatPriceProductTile(value, vendor, compare_at_price) {

        if (window.vip == true) {
            value = formatVIPPrice(value, vendor, compare_at_price);
        }

        var formattedPrice = formatPrice(value);
        //var split = formattedPrice.toString().split(".");

        var res = '';
        res +=
            '<div class="ais-hit--price-container">' +
            '<span class="ais-hit--price">' +
            '<div class="label-small" style="font-size: 12px">From</div>' +
            '<div class="flex-container">' +
            '<span class="h2 m-0 ais-hit--price-main"><span class="vendor-money" data-price="' + Number(value) * 100 + '" data-vendor="'+ vendor +'">' + formattedPrice + '</span></span>' +
            '<div class="flex-container flex-dir-column">';
        //if (split.length > 1) {
            //res += '<span class="h4 m-0">.' + split[1] + '</span>';
        //}
        res +=
            '<span class="text-smaller semibold">EX. GST</span>' +
            '</div>' +
            '</div>' +
            '</span>' +
            '</div>';

        return res;
    };

    function formattedPriceWithComparisonProductTile(price, compare_at_price, price_ratio, vendor, sku = '') {
        var comparing =
            Number(compare_at_price) && Number(compare_at_price) > Number(price);
        var discount_ratio = 1.0 - price_ratio;

        if (window.vip == true) {
            price = formatVIPPrice(price, vendor, compare_at_price);
        }

        var formattedPrice = formatPrice(price);
        //var split = formattedPrice.toString().split(".");
		
      	var curent_vendor = vendor;
        if(compare_at_price) curent_vendor = '';
      
        var res = '';
        var add_class;
        if (sku == 'DRA98931') { 
          add_class = 'rendered';
        } else {
          add_class = '';
        }
        res +=
            '<div class="ais-hit--price-container has-comparing">' +
              '<span class="ais-hit--price">' +
                '<div class="flex-container">' +
                      '<span class="h2 m-0 ais-hit--price-main"><span class="vendor-money ' + add_class + '" data-price="'+Number(price) * 100 +'" data-vendor="'+ curent_vendor +'">' + formattedPrice + '</span></span>' +
                      '<div class="flex-container flex-dir-column">';
                          //if (split.length > 1) {
                              //res += '<span class="h4 m-0">.' + split[1] + '</span>';
                          //}
        res +=
                          '<span class="text-smaller semibold">EX. GST</span>' +
                      '</div>' +
                  '</div>';
        res +=
            '<div class="fgc-compare  ais-hit--price-compare overline-uppercase"><span class="price-including">' + formatPriceInl(price) + '</span><span class="including-gst-label"> INC GST</span></div>';


        if (comparing) {
            res +=
                '<del class="fgc-compare  ais-hit--price-compare overline-uppercase price-was">Was '+ formatPrice(compare_at_price * 1.1) +'</del>';
        }
        res +=
              '</span>' +
            '</div>';
      if (comparing) {
      res += '<div class="icon-sale"><img src="' + window.theme.assetUrl +'sale.jpg"  alt="sale" /></div>';
      }
        return res;
    }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    wishlist: function wishlist(){
      if(this.meta.my_fields){
        if (this.meta.my_fields.display_pricing == true || this.meta.my_fields.display_pricing == "true") {

        }
      }
         else {
            var base_url = window.location.origin;
            var addVariantId = !this._distinct && this.objectID !== this.id;
            var url =
                base_url  +
                '/products/' +
                this.handle +
                (addVariantId ? '?variant=' + this.objectID : '');

            var html =
                '<div class="ais-hit--wishlist color-secondary-text">' +
                  '<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_' + this.id + '" data-swaction="addToWishlist" data-product-id="' + this.id + '" data-variant-id="' + this.objectID + '" data-product-url="' + url + '"></button>' +
              '</div>';

            return html;
        };
    },
    displayPricingClass: function displayPricingClass() {
      if(this.meta.my_fields){
        if (this.meta.my_fields.display_pricing == true || this.meta.my_fields.display_pricing == "true") {
            return 'call-for-pricing';
        }
      
      }
        
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if(this.meta.my_fields){
        if (this.meta.my_fields.display_pricing == true || this.meta.my_fields.display_pricing == "true") {
          return '<span><b>Call for Pricing</b></span>';
      }
      }
      

      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          //return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
          return '<span>From </span><b><span class="vendor-money" data-price="' + Number(min) * 100 + '" data-vendor="'+ this.vendor +'">' + formatPrice(min) + '</span></b>';
        }
      }

      //return formattedPriceWithComparison(this.price, null);
      return formattedPriceWithComparison(this.price, this.compare_at_price, null, this.vendor, this.sku);
    },
    instantsearchPrice: function instantsearchPrice() {
      if(this.meta.my_fields){
        if (this.meta.my_fields.display_pricing == true || this.meta.my_fields.display_pricing == "true") {
          return '<div class="h3 m-0">Call for Pricing</div>';
      }
      }
      

      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return formatPriceProductTile(min, this.vendor, this.compare_at_price);
        }
      }

      return formattedPriceWithComparisonProductTile(
        this.price,
        this.compare_at_price,
        this.price_ratio,
        this.vendor,
        this.sku
      );
    },
    instantsearchLink: function instantsearchLink() {
      var base_url = window.location.origin;
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        base_url  +
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    handle: function handle(text, render) {
        return render(text).toLowerCase().split(' ').join('-');
    },
    tooltipImage: function tooltipImage(text, render) {
        let format_text = render(text).toLowerCase().split('/').join('-');
        return '<img src="' + window.theme.assetUrl + 'tooltip-' + render(format_text).toLowerCase().split(' ').join('-') + '.svg" alt="Icon for ' + render(text) + '" title="' + render(text) + ' Tooltip"/>';
    },
    inventoryQuantity: function inventoryQuantity (){
//       if(this.inventory_quantity > 0){
//         if(this.inventory_quantity <= 3) return 'Only ' + this.inventory_quantity + ' left in stock';
//             return 'In Stock';
//       }else{
//         if(this.meta.availability){
//         	return this.meta.availability.message;
//         }
        
//       }
      if(this.variants_inventory_count  > 0){
        //if(this.variants_inventory_count  <= 3) return 'Only ' + this.variants_inventory_count  + ' left in stock';
        // if(this.variants_inventory_count  <= 3) return 'Low Stock';
        return 'In Stock';
      }else{
        if(this.meta.availability){
        	// return this.meta.availability.message;
          return 'Out of Stock';
        }
      }
      
    },
     tagPrint: function tagPrint () {
       var st_color = this.tags;
            
     // if (this.tags.includes('Redemption'))
     //   return "Redemption";
   // else return "hide";
  for ( i = 0; i < st_color.length; i++) {
  if (st_color[i].includes('Promo_')) {
    var label_promo_cl = st_color[i].split('_');
   // var color_pro_cl = label_promo_cl[1].split('_');
   return label_promo_cl[2];
  break;
  }
}
       
    },
      tagPrintPromoLabel: function tagPrintPromoLabel () {
       var st = this.tags;      
    // if (this.tags.indexOf('Promo_')!== -1) return this.tags; else return this.tags;
      //var st2 = this.tags.split(" ");
    //console.log("fgc:"+ this.tags);
      // if (this.tags.includes('Redemption'))
       //  return "Redemption";
    // else return "hide";
        var ck_promo = false; 

      
 // console.log("fgc:"+ st.length);
 // console.log("length:"+ st + st.length);
for (let i = 0; i < st.length; i++) {
 // text += "The number is " + i + "<br>";
 //console.log("fgc_"+i+ ":"+st[i]+"<br>");
 // console.log('Promo_'+ st[i].includes('Promo_'));
  if (st[i].includes('Promo_')) {
    var label_promo = st[i].split('_');
   // var color_pro = label_promo[1].split("_");
    return label_promo[1];
 break;
  }
}
    
      // return this.tags;
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
